import { render } from "./afterHomeworkCustomize.vue?vue&type=template&id=724ffd76&scoped=true"
import script from "./afterHomeworkCustomize.vue?vue&type=script&lang=js"
export * from "./afterHomeworkCustomize.vue?vue&type=script&lang=js"

import "./afterHomeworkCustomize.vue?vue&type=style&index=0&id=724ffd76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724ffd76"]])

export default __exports__